<template>
    <div>
        <Button plain type="info" size="small" @click.stop="openDialog">结束</Button>
        <template style="display: none">
            <baidu-map
                class="map"
                :zoom="zoom"
                :center="center"
                @ready="maphandler"
                ak="YhMUfwus3Ayed7BpBahtwR5KhFoKVkc0"
            >
                <bm-geolocation
                    anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
                    :showAddressBar="true"
                    :autoLocation="true"
                ></bm-geolocation>
            </baidu-map>
        </template>
    </div>
</template>
<script >
import { BaiduMap } from "vue-baidu-map";
import application from "@api/application";
import { Button } from "vant";
import { Dialog } from "vant";
export default {
    components: {
        BaiduMap,
        Dialog,
        Button,
    },
    props: {
        id: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            center: { lng: 0, lat: 0 },
            zoom: 15,
            address: "",
        };
    },
    methods: {
        openDialog() {
            const that = this;
            Dialog.confirm({
                title: "请确认车辆已在规定地点停放",
                message: this.address,
                beforeClose: function (action, done) {
                    console.log(that.id);
                    if (action === "confirm") {
                        application
                            .updateStatus({ id: that.id })
                            .then((res) => {
                                this.$toast("结束成功!");
                                that.$emit("refresh");
                                done();
                            });
                    } else {
                        done();
                    }
                },
            });
        },

        maphandler({ BMap, map }) {
            const that = this;
            let geolocation = new BMap.Geolocation();
            let gc = new BMap.Geocoder();
            geolocation.getCurrentPosition(function (r) {
                if (this.getStatus() == BMAP_STATUS_SUCCESS) {
                    console.log(new BMap.Marker(r.point));
                    that.center.lng = r.longitude;
                    that.center.lat = r.latitude;
                    console.log(that.center);
                    gc.getLocation(r.point, function (rs) {
                        let addComp = rs.addressComponents;
                        that.address =
                            addComp.province +
                            addComp.city +
                            addComp.district +
                            addComp.street +
                            addComp.streetNumber;
                    });
                } else {
                    alert("failed" + this.getStatus());
                }
            });
        },
    },
    mounted() {},
};
</script>